module.exports = __webpack_public_path__ + "static/media/512F3ED9-A561-4F71-9A61-3755098AFA02.30d433b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/512F3ED9-A561-4F71-9A61-3755098AFA02.jpg
// module id = 296
// module chunks = 0